// extracted by mini-css-extract-plugin
export default {"root":"compare_availability_mobile_page___root___b33f9dcd","item":"compare_availability_mobile_page___item___d61696e2","name":"compare_availability_mobile_page___name___d730c893"};